<template>
  <div>
    <section>
      <div class="cg-list-container px-2">
        <h1 class="pl-2">{{ currentCategoryName }}</h1>
        <section class="cg-list cg-list__category d-flex flex-wrap" :class="sizeOfBuildingArray">
          <div v-for="(building, index) in getCategoryTopics(currentCategoryId)" class="col-12 col-md-4 mx-0 px-0 my-2"
            :key="building.id + index">
            <router-link :to="{
              name: 'componentpage_view',
              params: {
                componentId: building.id,
                componentName: createUrlStringFromName(building.name),
                view: $t('hellovue.view.street_view'),
                scrollToTop: true
              },
            }" class="
                cg-list-item__link
                d-flex
                flex-column
                justify-content-center
                mx-0
                px-2
                fp-link
                text-decoration-none
              ">
              <img class="cg-list-item__img align-items-center mr-2 mr-md-0" :src="facadeImg(building.images)"
                :alt="facadeAlt(building.images)" />
              <div class="cg-list-item__content">
                <h2 class="item__name">{{ building.name }}</h2>
                <p class="item__description">{{ building.description }}</p>
              </div>
            </router-link>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>
<script>
import { createUrlString } from "src/store/helpers";
import { mapGetters } from "vuex";
import ComponentGalleryHeader from "src/components/partials/ComponentGalleryHeader.vue";

export default {
  name: "CategoryPage",
  data() {
    return {};
  },
  components: {
    ComponentGalleryHeader,
  },
  computed: {
    ...mapGetters(["getCategoryTopics", "getCategories"]),
    sizeOfBuildingArray: function () {
      if (!this.currentCategoryId) return;

      if (this.getCategoryTopics(this.currentCategoryId).size <= 2) {
        return "justify-content-center";
      } else if (this.getCategoryTopics(this.currentCategoryId).size % 3 != 0) {
        return "justify-content-start";
      } else {
        return "justify-content-between";
      }
    },
    currentCategory: function () {
      return this.getCategories.find((cat) => createUrlString(cat.name) == this.$route.params.categoryName)
    },
    currentCategoryId: function () {
      if (this.currentCategory && this.currentCategory.id) return this.currentCategory.id;
      return undefined;
    },
    currentCategoryName: function () {
      if (this.currentCategory && this.currentCategory.name) return this.currentCategory.name;
      return undefined;
    }
  },
  methods: {
    createUrlStringFromName(name) {
      return createUrlString(name);
    },
    facadeImg(objects) {
      let imgUrl = "";
      for (let i = 0; i < objects.length; i++) {
        if (objects[i].type === "Julkisivukuva") {
          imgUrl = objects[i].imageUrl;
        }
      }
      return imgUrl;
    },
    facadeAlt: (objects) => {
      let imgAlt = "";
      for (let i = 0; i < objects.length; i++) {
        if (objects[i].type === "Julkisivukuva") {
          imgAlt = objects[i].imageAlttext;
        }
      }
      return imgAlt;
    },
  }
};
</script>
<style scoped lang="scss">
.cg-list-item__img {
  height: 200px;
  object-fit: contain;
}

.text-decoration-none {
  text-decoration: none;
}
</style>